import { combineReducers } from 'redux';
import dailerReducer from './dailerReducer';

// Combine all reducers.
const appReducer = combineReducers({
  dailer: dailerReducer
});

export default appReducer;
